module.exports = __webpack_public_path__ + "img/99.6b87c5d5.jpg";